export default {
  stack: []
};
